import { createContext, useState } from "react";

export const JudicialRecordsContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    const [dataSearch, setDataSearch] = useState({ nameApi: null, status: null, code: null, unitCode: null });
    const [selectedItem, setSelectedItem] = useState(null);
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: 0,
    });
    const [totalRecords, setTotalRecords] = useState(0);
    const [listJudicial, setListJudicial] = useState([]);
    const [loading, setLoading] = useState(false);
    const [checkLoad, setCheckLoad] = useState(true);
    const [openDialogView, setOpenDialogView] = useState(null);

    // Make the context object:
    const judicialContext = {
        dataSearch,
        setDataSearch,
        selectedItem,
        setSelectedItem,
        lazyParams,
        setLazyParams,
        totalRecords,
        setTotalRecords,
        listJudicial,
        setListJudicial,
        loading,
        setLoading,
        checkLoad,
        setCheckLoad,
        openDialogView,
        setOpenDialogView,
    };

    // pass the value in provider and return
    return <JudicialRecordsContext.Provider value={judicialContext}>{children}</JudicialRecordsContext.Provider>;
};

export const { Consumer } = JudicialRecordsContext;
